import getScenarioStore from '../selectors/getScenarioStore';
import { createDefaultSearchStore } from '../store/store';
import { mutator } from 'satcheljs';
import { setCurrentSuggestions } from '../actions/publicActions';
import { setSelectedSuggestionIndex } from '../actions/internalActions';

mutator(setSelectedSuggestionIndex, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).selectedSuggestionIndex =
        actionMessage.selectedSuggestionIndex;
});

/**
 * When suggestions are updated in the store, reset the selectedSuggestionIndex
 * since the selected suggestion will have been removed from the store.
 */
mutator(setCurrentSuggestions, actionMessage => {
    getScenarioStore(
        actionMessage.scenarioId
    ).selectedSuggestionIndex = createDefaultSearchStore().selectedSuggestionIndex;
});
